import { useState } from 'react';
import Dialog from '../../components/Dialog';
import AdventureForm from './AdventureForm';

export default function AdventureDialog({ visible, hide, item, preloaded, ...props }) {
  const [loading, setLoading] = useState(false);

  return (
    <Dialog
      title={item ? 'Update QnA Activity' : 'Create QnA Activity'}
      visible={visible}
      onCancel={hide}
      closable={!loading}
    >
      <AdventureForm
        {...props}
        id={item?.id}
        item={preloaded ? item : undefined}
        submitting={loading}
        setSubmitting={l => setLoading(l)}
        onCancel={hide}
      />
    </Dialog>
  );
}
